import { Contract } from '../redux/reducers/clients';
import { fetchRequest } from '../services/http.service';

export const GET_CONTRACTS_URL = '/contracts/client/'

export const getContractsRequest = (clientId: Number | null) =>
  fetchRequest.get<Contract[]>(GET_CONTRACTS_URL + '?clientId=' + clientId)
